import { getDashboard, getDashboardDeal } from '@/services/apiMapper';
import { FILTERS } from '@/config/STATUS_GROUP';
import { ACTION, MUTATION, GETTER } from './CONSTANTS';

export default {
  async [ACTION.FETCH_DASHBOARD]({ commit }) {
    commit(MUTATION.SET_LOADING, true);
    try {
      const activeDashboard = await getDashboard(FILTERS.ACTIVE);
      commit(MUTATION.SET_DASHBOARD, activeDashboard);

      commit(MUTATION.SET_LOADING, false);

      const inactiveDashboard = await getDashboard(FILTERS.INACTIVE);
      commit(MUTATION.SET_DASHBOARD, inactiveDashboard);
    } catch (error) {
      commit(MUTATION.SET_ERROR, error);
    } finally {
      commit(MUTATION.SET_LOADING, false);
    }
  },
  async [ACTION.FETCH_EXPANDED_DEAL]({ getters, commit }, { dealUid }) {
    try {
      const shouldShowLoading = getters[GETTER.EXPANDED_DEAL] === null;
      if (shouldShowLoading) commit(MUTATION.SET_EXPANDED_DEAL_LOADING, true);
      const expandedDeal = await getDashboardDeal({ dealUid });
      commit(MUTATION.SET_EXPANDED_DEAL, expandedDeal);
      if (shouldShowLoading) commit(MUTATION.SET_EXPANDED_DEAL_LOADING, false);
    } catch (error) {
      commit(MUTATION.SET_ERROR, error);
    }
  },
};
